import { Uuid } from "../../../domain/model/uuid/uuid.type";
import { SyncStoreLastServerSyncInfo } from "../model/sync-store-last-server-sync-info";
import { SyncStoreUpdateTypeEnum } from "../sync-store-enums";
import { SyncStoreUpdateData } from "../sync-store-update-data";

export class SyncStoreUpdateRemoval implements SyncStoreUpdateData {
  readonly updateType: SyncStoreUpdateTypeEnum = SyncStoreUpdateTypeEnum.Create;

  constructor(
    readonly id: Uuid,
    readonly lastKnownServerUpdate: SyncStoreLastServerSyncInfo,
    readonly date: Date,
    readonly pen: string,
    readonly numberOfAnimals: number,
    readonly weight: number,
    readonly code: string,
    readonly reason: string,
  ) {}
}
